import React from 'react'

type Variant =
  | 'default'
  | 'outline'
  | 'violet'
  | 'outline-violet'
  | 'danger'
  | 'outline-danger'
  | 'link'

interface ButtonProps {
  name?: string
  className?: string
  type?: 'button' | 'submit'
  variant?: Variant
  loading?: boolean
  label?: string
  icon?: React.ReactNode
  iconPosition?: 'left' | 'right'
  // children?: React.ReactNode
  onClick?: () => void
  disabled?: boolean
  children?: React.ReactNode
}

const Button: React.FC<ButtonProps> = ({
  type = 'button',
  disabled,
  className = '',
  name = '',
  icon,
  iconPosition = 'right',
  loading = false,
  label,
  // children,
  onClick,
  variant = 'default',
  ...props
}) => {
  const variants: Record<Variant, string> = {
    default: 'flex items-center justify-center bg-blue-900 border text-white',
    outline:
      'flex items-center justify-center border border-blue-900 bg-blue-100 text-blue-900 hover:bg-blue-900 hover:text-white',
    violet:
      'flex items-center justify-center bg-violet-600 border hover:border-violet-600 text-white hover:text-violet-600 hover:bg-violet-100',
    'outline-violet':
      'flex items-center justify-center border border-violet-600 bg-violet-100 text-violet-600 hover:bg-violet-600 hover:text-white',
    danger:
      'flex items-center justify-center border bg-red-600 text-white hover:bg-red-100 hover:text-red-600 hover:border-red-600',
    'outline-danger':
      'flex items-center justify-center border border-red-600 bg-red-100 text-red-600 hover:bg-red-600 hover:text-white',
    link: 'bg-transparent'
  }

  const styles = variants[variant] || variants.default

  return (
    <button
      name={name}
      type={type}
      className={`text-sm leading-2 font-medium transition ${variant !== 'link' ? 'min-h-[40px] w-fit rounded-full px-8 py-2' : 'rounded-none p-0'} ${styles} ${className} ${loading || disabled ? 'cursor-not-allowed opacity-50' : ''} `}
      disabled={disabled || loading}
      onClick={onClick}
      {...props}
    >
      {loading ? (
        <span className="is-loading"></span>
      ) : (
        <span className="flex items-center gap-x-2 leading-none">
          {iconPosition === 'left' && icon}
          {label}
          {iconPosition === 'right' && icon}
        </span>
      )}
    </button>
  )
}

export default Button
